<section class="guide-page">
    <div class="page-banner">
        <h1>{{ pageTitle }}</h1>
    </div>

    <section class="intro-copy">
        <p><strong>Risk Score Formula:</strong> {{ introContent.riskScoreFormula }}</p>
        <p class="risk-details">{{ introContent.riskScoreDetails }}</p>
        <p><strong>Potential Reliability Risk Candidacy Rule:</strong> {{ introContent.badActorCandidacyRule }}</p>
        <p><strong>Criticality Source:</strong> {{ introContent.criticalitySource }}</p>
        <p><strong>Guardrails:</strong> {{ introContent.guardrails }}</p>
    </section>

    <section class="section-block">
        <h2 class="scoring-title">
            <span class="section-icon" aria-hidden="true">&#128221;</span>
            <span>{{ scoringReferenceTitle }}</span>
        </h2>
        <p>{{ scoringReferenceText }}</p>

        <h3>{{ canonicalTitle }}</h3>
        <div class="formula-box">
            <pre>{{ canonicalFormulaLines.join('\n') }}</pre>
        </div>

        <h3>{{ aiAdjustedTitle }}</h3>
        <div class="formula-box">
            <pre>{{ aiAdjustedContentLines.join('\n') }}</pre>
        </div>

        <h3>{{ explainabilityTitle }}</h3>
        <div class="formula-box">
            <pre>{{ explainabilityFormulaLines.join('\n') }}</pre>
        </div>

        <table class="method-table feature-table">
            <thead>
                <tr>
                    <th *ngFor="let column of featureTable.columns">{{ column.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of featureTable.rows">
                    <td *ngFor="let column of featureTable.columns">{{ row[column.key] }}</td>
                </tr>
            </tbody>
        </table>

        <h3>{{ riskTrendTitle }}</h3>
        <table class="method-table risk-trend-table">
            <thead>
                <tr>
                    <th *ngFor="let column of riskTrendTable.columns">{{ column.label }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of riskTrendTable.rows">
                    <td>
                        <span [class]="getStatusClass(row)">{{ row.status }}</span>
                    </td>
                    <td>{{ row.condition }}</td>
                </tr>
            </tbody>
        </table>

        <div class="risk-trend-note">
            <p>
                Prior-month scores are loaded from <code>sentry_chain/output/monthly_scores.json</code> (global cross-run history).
            </p>
            <p>
                {{ riskTrendNoteLine2Prefix }}
                <span class="status new">NEW</span>.
            </p>
        </div>
    </section>
</section>